// extracted by mini-css-extract-plugin
export default {"alert-container":"styles_alert-container__lOjJy","dialogstyle":"styles_dialogstyle__-u3DC"};